<template>
    <div class="msg">
        <div class="share-mes-box">
            <div class="share-close">
                <div class="share-close-click fr" @click="close">×</div>
            </div>
            <div id="QRCode"></div>
            <div class="shareType">
                <!-- <input class="web-url" v-model="web" type="text" readonly="readonly"> -->
                <!-- <br> -->
                <!-- <button v-text="copy" @click="urlCopy"></button> -->
                <button type="button" :title="down" v-text="down" @click="open"></button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'ShareBomb',
    data(){
        return{
            web:'',
            copy:'',
            down:'',
            lan:''
        }
    },
    methods:{
        setQRCode:function(web){
            this.web=web;
            var code=$('#QRCode');
            code.empty();
            new this.QRCode(code.get(0),{
                text:web,
                width:120,
                height:120
            })
        },
        close:function(){
            this.$emit('close',false);
        },
        urlCopy:function(){
            var Url2=$('.web-url').eq(0).get(0);
            Url2.select(); // 选择对象
            document.execCommand("Copy");
            alert(this.lan['K118_Copy_Success']);
        },
        open:function(){
            window.open(this.web);
        },
        lang:function(lan){
            this.lan=this.lanSave[lan];
            this.copy=this.lan['K117_Copy'];
            this.down=this.lan['K162_Down'];
        }
    },
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
    }
    .share-mes-box{
        width:400px;
        height:300px;
        background-color: #11366a;
        font-size:12px;
        position:absolute;
        top:50%;
        left:50%;
        margin-top:-150px;
        margin-left:-200px;
        box-sizing: border-box;
    }
    .share-close{
        width:100%;
        height: 20px;
        text-align:right;
    }
    .share-close-click{
        line-height: 20px;
        font-size:20px;
        font-weight: bold;
        cursor: default;
        color:#fff;
    }
    .shareType{
        width:100%;
        height:120px;
        text-align: center;
        margin-top:20px;
    }
    #QRCode{
        width:140px;
        height:140px;
        border:10px solid #fff;
        margin-top:0;
        margin:0 auto;
        box-sizing: border-box;
    }
    .shareType button{
        width: 120px;
        height: 30px;
        color: #fff;
        background-color: #0c5297;
        box-sizing: border-box;
        border: none;
        border-radius: 5px;
        outline: none;
        margin-top:20px;
        box-sizing: border-box;
        overflow:hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .shareType button:hover{
        background-color: #0193ff;
    }
    .web-url{
        width: 360px;
        height: 25px;
        box-sizing: border-box;
        border: 1px solid #ccc;
        outline: none;
    }
</style>





// WEBPACK FOOTER //
// src/components/ShareBomb.vue